<template>
  <div id="search">
    <b-container fluid>
      <h4>Last Updated: {{lastUpdated}}</h4>
      <p></p>
      <p>This data is provided to you by the CHIME/FRB collaboration. If you use this data, please use the following acknowledgement: <br> <b style="color:green">We acknowledge use of the CHIME/FRB Public Database, provided at https://www.chime-frb.ca/ by the CHIME/FRB Collaboration.</b></p>
      <h2 style="margin-bottom: 25px; margin-top: 20px">Galactic Sources (Total: {{filteredItems.length}} sources)</h2>
      <!--<h2 v-else>Coming soon ... Please stay tuned :) </h2>-->
      <b-row>
        <b-col xl="12" md="8" sm="7">
          <b-row>
            <b-col md="2" class="my-1">
              <!-- <b-form inline>
                <label class="mr-sm-2"> Per page </label>
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form> -->
            </b-col>
            <b-col md="2" class="my-1">
              <!-- <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              /> -->
            </b-col>
            <b-col md="4" class="my-1">
               <a class="download-button"
                :href="downloadData"
                :download="'galactic.json'">
                <b-button variant="dark"> 
                  Download Galactic Sources
                </b-button> 
              </a>
            </b-col>
            <b-col md="4" class="my-1">
              <b-form inline>
                <label class="mr-sm-2">Filter:</label>
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search" />
                    <b-input-group-append>
                      <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                    </b-input-group-append>
                  </b-input-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" v-if="filteredItems.length != 0">
              <b-table
                small
                hover
                striped
                outlined
                :items="filteredItems" 
                :fields="galacticFields"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
              <template v-slot:cell(action)="data">
              <div class="zoom">
                <b-link v-bind:href=data.item.prepfoldplot target="_blank">
                  <b-img-lazy :src=data.item.prepfoldplot
                            width='50px'
                            height='50px'
                />
                </b-link>
              </div>  
              </template>
              </b-table>
            </b-col>
            <b-col md="12" v-else>
              <p>Loading...</p>
              <b-spinner
                v-for="variant in variants"
                :variant="variant"
                :key="variant"
                type="grow"
              ></b-spinner>
            </b-col>
          </b-row>         
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {filterMixin} from './mixins/filter_mixin.js'
export default {
  name: "search",
  mixins: [filterMixin],
  data() {
    return {
      galacticFields: [
        {key: 'source_id', label: 'Name', sortable: true},
        {key: 'dm', label: 'DM', sortable: true},
        {key: 'ra', label: 'RA', sortable: true},
        {key: 'dec', label: 'Dec', sortable: true},
        {key: 'period', label: 'Spin Period (s)', sortable: true},
        {key: 'action', label: 'Plot'}
      ],
      options: [
        { value: null, text: this.$t('latestSelect')},
        { value: 'id', text: 'ID'},
        { value: 'dm', text: 'DM'},
        { value: 'date', text: 'Date'},
        { value: 'ra', text: 'RA'},
        {value: 'dec', text: 'Dec'},
        { value: 'snr', text: 'SNR'}
      ],
      // perPage: 100000,
      eventsItems: [],
      filteredItems: [],
      whichEvents: "Galactic"
    }
  },
  mounted() {
    this.generateItems()
    this.fetchLastUpdated('pulsars')
  },
  methods: {
    generateItems () {
      // Generate a master list of Repeater objects
      this.noResultsFound = false
      var url = 'https://catalog.chime-frb.ca/galactic'
      // var url = 'http://localhost:8081/galactic'
      // Fetch all repeaters
      return this.$http.get(url, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseResponse(response.body)
        })
    },
    parseResponse (sources) {
      // Parse data for all bursts and generate an FRB master list
      this.downloadItems = sources
      var sourceNames = Object.keys(sources)
      // https://storage.cloud.google.com/chimefrb-dev.appspot.com/J2108%2B45/J2108%2B45_prepfold.png
      this.totalRows = sourceNames.length
      for (var i = 0; i < sourceNames.length; i++) {
        var base_link = 'https://storage.googleapis.com/chimefrb-dev.appspot.com/' + sourceNames[i]
        var item = {}
        item['source_id'] = sourceNames[i]
        item['dm'] = sources[sourceNames[i]]['dm'].value
        item['ra'] = sources[sourceNames[i]]['ra'].value
        item['dec'] = sources[sourceNames[i]]['dec'].value
        item['period'] = sources[sourceNames[i]]['period'].value
        item['prepfoldplot']= base_link + '/' + sourceNames[i] + '_prepfold.png'
        console.log(item['prepfoldplot'])
        this.items.push(item)
      }
      this.filterItems()
      this.whichEvents = "Galactic"
    },
    filterItems () {
      // Filters the master list and generates a list of filtered items
      this.whichEvents = "Filtered"
      this.noResultsFound = false
      this.filteredItems = []
      // Loop through the master list, check if each item is to be added based on the first burst parameters,
      // parse added items a bit
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i]
        if (this.isToBeAdded(item) || (Object.entries(this.search_parameters).length === 0 &&
            this.search_parameters.constructor === Object)) {
          var filteredItem = {
            dm: (['string', 'number'].includes(typeof item['dm'])) ? item['dm']: "",//.toFixed(2),
            ra: (['string', 'number'].includes(typeof item['ra'])) ? item['ra']: "",// .toFixed(2),
            dec: (['string', 'number'].includes(typeof item['dec'])) ? item['dec']: "",// .toFixed(2),
            source_id: item['source_id'],
            period: (['string', 'number'].includes(typeof item['period'])) ? item['period']: "",//.toFixed(2),
            prepfoldplot: item['prepfoldplot']
          }
          this.filteredItems.push(filteredItem)
        }
      }
      this.totalRows = this.filteredItems.length
      if (this.filteredItems.length == 0){
        this.noResultsFound = true
      }
    },
  }
}
</script>
<style>
.supsub {position: absolute}
.subscript {display:block; position:relative; left:2px; bottom: -18px}
.superscript {display:block; position:relative; left:2px; top: 2px}
.download-button {
    display: flex;
    justify-content: center;
    padding: 5px;
    color: #fff;
    opacity: 0.87;
    text-align: center;
}
.zoom:hover {
  transform: scale(5);
}
</style>